<template>
    <div class="content-buttons-wrapper">
        <div v-if="buttonsList.type === 'download'">
            <button
                class="button button-primary"
                :class="{
                    'show-download-options': showDownloadOptions,
                    'button-multi-download': Object.keys(software).length > 1,
                    'button-download-content': Object.keys(software).length < 1,
                    'button-alternate': isFree || (authUser && packageIsFree),
                    'pulse button-invert': pulse === id,
                }"
                :data-has-user="!!authUser"
                @click="buttonEvent(userUrl, $event)"
                :data-can-download="isFree || packageIsFree || (authUser && !limits && canAccess) ? true : false"
                :data-link="userUrl"
            >
                <div class="button-multi-download-software" v-if="Object.keys(software).length > 1">
                    <i class="icon icon-close" @click.stop="showDownloadOptions = false"></i>
                    <div v-for="(soft, index) in software" :key="index">
                        <div v-if="soft.image_software">
                            <img
                                :src="soft.image_software?.url"
                                :alt="soft.locale?.name"
                                :title="t.buttons.download_2 + ' ' + t.account.for + ': ' + soft.locale?.name"
                                class="useContent"
                                @click="buttonUseContent(userUrl + '/' + soft.id, $event)"
                                :data-link="userUrl + '/' + soft.id"
                            />
                        </div>
                    </div>
                </div>
                <span class="button-label" v-if="isFree || packageIsFree">{{
                    t.buttons.free_download
                }}</span>
                <span class="button-label" v-else>{{ t.buttons.download }}</span>
            </button>
        </div>
        <div v-else-if="buttonsList.type === 'download_single'">
            <button
                class="button button-primary"
                :class="{
                    'show-download-options': showDownloadOptions,
                    'button-multi-download': Object.keys(software).length > 1,
                    'button-download-content': Object.keys(software).length < 1,
                    'pulse button-invert': pulse === id,
                }"
                data-has-user="1"
                @click="buttonEvent(singleDownloadUrl)"
                :data-can-download="1"
                :data-link="singleDownloadUrl"
            >
                <div class="button-multi-download-software" v-if="Object.keys(software).length > 1">
                    <i class="icon icon-close" @click.stop="showDownloadOptions = false"></i>
                    <div v-for="soft in software">
                        <img
                            v-if="soft.image_software"
                            :src="soft.image_software?.url"
                            class="useSingleContent"
                            @click="buttonUseSingleContent(singleDownloadUrl + '/' + soft.id)"
                            :alt="soft.locale?.name"
                            :title="t.buttons.download_2 + ' ' + t.account.for + ': ' + soft.locale?.name"
                            :data-link="singleDownloadUrl + '/' + soft.id"
                        />
                    </div>
                </div>
                <span class="button-label">{{ t.buttons.download }}</span>
            </button>
        </div>
        <div v-else-if="buttonsList.type === 'add_to_cart'">
            <button
                class="button button-alternate button-download-content asset-add-to-cart-button"
                :class="{'pulse button-invert': pulse === id}"
                :title="buttonsList.tooltip"
                :id="buttonsList.id"
                @click.prevent="addToCart($event, buttonsList.data_content)"
                :data-content="buttonsList.data_content"
            >
                <span class="button-label">{{ buttonsList.text_button }}</span>
                <div class="loading-area-overlay">
                    <div class="spinner">Loading...</div>
                </div>
            </button>
        </div>
        <div v-else>
            <button
                class="button button-alternate button-download-content asset-action-button"
                :class="{'pulse button-invert': pulse == id}"
                :title="buttonsList.tooltip"
                :data-type="buttonsList.type"
                @click="goToHref(buttonsList.url)"
                :data-url="buttonsList.url"
            >
                <span class="button-label">{{ buttonsList.text_button }}</span>
            </button>
        </div>

        <div
            class="single-content-price"
            v-if="buttonsList.type !== 'download' && buttonsList.type !== 'download_single'"
        >
            <Currency :value="price" />
        </div>
    </div>
</template>

<script>
import { usePackageStore } from "@/frontend/package-store.ts"
import axios from "@/app/axios.ts"
import Currency from "@/components/BaseCurrency.vue"
const translationsData = window.translationsData

export default {
    name: "ContentButtons",
    components: { Currency },
    props: ["id", "packageIsFree"],
    data() {
        return {
            buttonsList: [],
            authUser: false,
            limits: false,
            canAccess: false,
            scrollListenerActive: false,
            singleDownloadUrl: null,
            showDownloadOptions: false,
            software: {},
            userUrl: false,
            isFree: false,
            price: false,
            t: translationsData.translations,
            globalRoute: window.translationsData.global_route,
            isDesktop: window.innerWidth > 992,
            packageStore: usePackageStore(),
        }
    },
    methods: {
        checkScreenSize() {
            this.isDesktop = window.innerWidth > 992
        },
        async buttonEvent(url, event) {
            await this.getSoftware()
            if (Object.keys(this.software).length > 1) {
                this.showDownloadOptions = true
            } else {
                if (this.buttonsList.type === "download") {
                    this.buttonUseContent(url, event)
                } else if (this.buttonsList.type === "download_single") {
                    this.buttonUseSingleContent(url)
                }
            }
        },
        async buttonUseContent(url, event) {
            window.useContent(url, event)
            await this.contentIsUsed(this.id)
        },
        async buttonUseSingleContent(url) {
            window.useSingleContent(url)
            await this.contentIsUsed(this.id)
        },
        goToHref(href) {
            window.location.href = href
        },
        async addToCart(event, contentID) {
            if (contentID) {
                let btnToSwitch = document.querySelector(`button[data-content='${contentID}']`)
                event.currentTarget.querySelector(".loading-area-overlay").classList.add("shown")
                event.currentTarget.querySelector(".button-label").classList.add("hidden")
                try {
                    const response = await axios.post(
                        "/" +
                            window.translationsData.global_route.locale +
                            "/" +
                            window.translationsData.translations.routes.cart +
                            "/add",
                        {
                            content_id: contentID,
                        },
                    )
                    if (response) {
                        try {
                            window.eventBus && window.eventBus.$emit("content_added_to_cart", contentID)
                            btnToSwitch.querySelector(".button-label").innerText = this.t.buttons.added_to_cart
                            btnToSwitch.title = this.t.buttons.added_to_cart
                            btnToSwitch.addEventListener(
                                "click",
                                () => (window.location.href = window.translationsData.global_route.cart),
                            )
                            btnToSwitch.querySelector(".loading-area-overlay").classList.remove("shown")
                            btnToSwitch.querySelector(".button-label").classList.remove("hidden")
                            window.location.href = window.translationsData.global_route.cart
                        } catch (error) {
                            btnToSwitch.querySelector(".loading-area-overlay").classList.remove("shown")
                            btnToSwitch.querySelector(".button-label").classList.remove("hidden")
                        }
                    }
                } catch (e) {
                    this.$error(e)
                }
            }
        },
        async getSoftware() {
            const response = await axios.post(`/${this.globalRoute.locale}/content/software/${this.id}`)
            if (response) {
                this.software = response.data
            }
        },
        async contentIsUsed(id) {
            try {
                const url = `/is-used/${id}`
                const response = await axios.get(url)

                if (response) {
                    let contentWrapper = document.getElementById("content-" + id)
                    contentWrapper.querySelectorAll(".container-asset-image").forEach((item)=>{
                        item.classList.add("checked")
                    })
                }
            } catch (e) {
                console.error(e)
            }
        },
    },
    mounted() {
        window.addEventListener("resize", this.checkScreenSize)
    },
    unmounted() {
        window.removeEventListener("resize", this.checkScreenSize)
    },
    computed: {
        pulse() {
            if (window.location.hash.startsWith("#content-") && this.isDesktop) {
                const id = window.location.hash.match(/#content-(\d+)/)?.[1]
                return Number(id)
            }
            return null
        },
    },
    async created() {
        await this.packageStore.fetchPackageContentsData()
        this.content = this.packageStore.getContentById(this.id)
        this.buttonsList = this.content.button
        this.authUser = this.packageStore.getAuthUser()
        this.limits = this.packageStore.getLimits()
        this.canAccess = this.packageStore.getCanAccess()
        this.userUrl = this.content.userUrl
        this.singleDownloadUrl = this.content.single_download_url
        this.isFree = this.content.isFree
        this.price = this.content.price
    },
}
</script>

<style lang="scss" scoped>
.content-buttons-wrapper {
    display: flex;
    align-items: center;
    justify-content: space-between;
    flex: 1;
}

.pulse {
    animation: pulse 3s infinite;
}
</style>
